/* eslint-disable no-throw-literal */
import { v4 as uuidv4 } from 'uuid';
import { API_URL } from '../config/env';

const url = window.location.href;
const urlParams = new URL(url);

const sidParam = urlParams.searchParams.get('sid');
const groupParam =
	urlParams.searchParams.get('grupo') ||
	urlParams.searchParams.get('GRUPO') ||
	urlParams.searchParams.get('src') ||
	urlParams.searchParams.get('SRC');
const codrevParam =
	urlParams.searchParams.get('codrev') ||
	urlParams.searchParams.get('codRev') ||
	urlParams.searchParams.get('coderev') ||
	urlParams.searchParams.get('CODREV') ||
	urlParams.searchParams.get('COD_REV') ||
	urlParams.searchParams.get('cod_rev');
const arParam =
	urlParams.searchParams.get('ar') ||
	urlParams.searchParams.get('cliente_AR') ||
	urlParams.searchParams.get('cliente_ar') ||
	urlParams.searchParams.get('CLIENTE_AR') ||
	urlParams.searchParams.get('AR');

const saveParamsToSession = () => {
	const params = {
		sid: sidParam,
		group: groupParam,
		codrev: codrevParam,
		ar: arParam,
	};
	sessionStorage.setItem('urlParams', JSON.stringify(params));
};

const getParamsFromSession = () => {
	const storedParams = sessionStorage.getItem('urlParams');
	return storedParams ? JSON.parse(storedParams) : {};
};

const removeUrlParams = () => {
	const cleanUrl = url.split('?')[0];
	window.history.replaceState({}, document.title, cleanUrl);
};

if (sidParam || groupParam || codrevParam || arParam) {
	saveParamsToSession();
	removeUrlParams();
}

const { sid = '', group = '', codrev = '', ar = '' } = getParamsFromSession();

interface RequestOptions extends RequestInit {
	headers?: Record<string, string>;
}

export const API = {
	async request(endpoint: string, options: RequestOptions = {}) {
		const correlationId = uuidv4();
		const defaultHeaders: Record<string, string> = {
			sid: sid || '',
			'Content-Type': 'application/json',
			'x-correlation-id': correlationId,
		};

		const config: RequestOptions = {
			...options,
			headers: {
				...defaultHeaders,
				...(options.headers || {}),
			},
		};

		const queryString = new URLSearchParams({
			...(ar ? { ar } : {}),
			...(group ? { grupo: group } : {}),
			...(codrev ? { codrev } : {}),
		}).toString();

		const fullUrl = queryString
			? `${API_URL}${endpoint}?${queryString}`
			: `${API_URL}${endpoint}`;

		try {
			const response = await fetch(fullUrl, config);

			if (!response.ok) {
				const errorResponse = await response.json().catch(() => null);
				console.error(errorResponse);

				throw {
					statusCode: response.status,
					correlationId: errorResponse.correlationId,
					message: errorResponse?.message || 'Erro desconhecido',
					code: errorResponse?.code || 'UNKNOWN_ERROR',
				};
			}

			return response.json();
		} catch (error) {
			console.error('Erro ao fazer a requisição:', error);
			throw error;
		}
	},
};

export const postRequest = async (
	endpoint: string,
	data: Record<string, any>
) => {
	const { sid = '' } = getParamsFromSession();
	const correlationId = uuidv4();

	const fullUrl = `${API_URL}${endpoint}`;

	const config: RequestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			sid: sid,
			'x-correlation-id': correlationId,
		},
		body: JSON.stringify(data),
	};

	try {
		const response = await fetch(fullUrl, config);

		if (!response.ok) {
			const errorResponse = await response.json().catch(() => null);
			console.error('Erro na requisição:', errorResponse);
			throw {
				statusCode: response.status,
				correlationId: errorResponse.correlationId,
				message: errorResponse?.message || 'Erro desconhecido',
				code: errorResponse?.code || 'UNKNOWN_ERROR',
			};
		}

		return response.json();
	} catch (error) {
		console.error('Erro ao fazer a requisição POST:', error);
		throw error;
	}
};
